import { useState, useRef } from 'external/react';

interface TableToolbarProps {
  pattern?: string;
  onSearch: (pattern: string | undefined) => void;
}

const ClientsTableToolbar = ({ pattern, onSearch }: TableToolbarProps) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [draft, setDraft] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const openSearch = () => {
    setSearchOpen(true);
    setDraft(pattern ?? '');
    setTimeout(() => inputRef.current?.focus(), 50);
  };

  const commitSearch = () => {
    onSearch(draft || undefined);
    setSearchOpen(false);
    setDraft('');
  };

  const clearPattern = () => {
    onSearch(undefined);
    setSearchOpen(false);
    setDraft('');
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') commitSearch();
    if (e.key === 'Escape') setSearchOpen(false);
  };

  return (
    <div className="d-flex align-items-center gap-2 mb-3">
      {pattern && !searchOpen && (
        <span className="badge bg-primary d-flex align-items-center gap-1" style={{ fontSize: '0.85rem' }}>
          🔍 {pattern}
          <button
            onClick={clearPattern}
            className="btn-close btn-close-white ms-1"
            style={{ fontSize: '0.6rem' }}
            aria-label="Limpiar búsqueda"
          />
        </span>
      )}
      {searchOpen ? (
        <div className="d-flex align-items-center gap-1">
          <input
            ref={inputRef}
            className="form-control form-control-sm"
            style={{ width: 200 }}
            value={draft}
            onChange={e => setDraft(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Buscar..."
          />
          <button className="btn btn-sm btn-primary" onClick={commitSearch}>Aplicar</button>
          <button className="btn btn-sm btn-outline-secondary" onClick={() => setSearchOpen(false)}>✕</button>
        </div>
      ) : (
        <button className="btn btn-sm btn-outline-secondary" onClick={openSearch} title="Buscar">
          🔍
        </button>
      )}
    </div>
  );
};

export default ClientsTableToolbar;